import { render, staticRenderFns } from "./settingsSearch.vue?vue&type=template&id=099b19b1"
import script from "./settingsSearch.vue?vue&type=script&lang=js"
export * from "./settingsSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports